import React from 'react';
import { Box, Typography } from '@mui/material';

const CHANGED_BG    = '#fffbeb';
const CURRENT_CLR   = '#92400e';  // amber-900
const PROPOSED_CLR  = '#15803d';  // green-700
const DEFAULT_CLR   = '#374151';

export default function FieldRow({ label, value, isChanged = false, side = 'proposed' }) {
  const isCurrentSide = side === 'current';
  const color = isChanged
    ? (isCurrentSide ? CURRENT_CLR : PROPOSED_CLR)
    : DEFAULT_CLR;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        px: 2,
        py: 0.75,
        bgcolor: isChanged ? CHANGED_BG : 'transparent',
        borderBottom: '1px solid #f1f5f9',
        '&:last-child': { borderBottom: 0 },
        alignItems: 'flex-start',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: '#6b7280',
          fontWeight: 600,
          minWidth: 110,
          flexShrink: 0,
          mt: '2px',
          fontSize: 11,
          lineHeight: 1.4,
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color,
          fontWeight: isChanged && !isCurrentSide ? 600 : 400,
          textDecoration: isChanged && isCurrentSide ? 'line-through' : 'none',
          opacity: isChanged && isCurrentSide ? 0.65 : 1,
          wordBreak: 'break-word',
          whiteSpace: 'pre-wrap',
          lineHeight: 1.5,
          fontSize: 12.5,
        }}
      >
        {value ?? '—'}
      </Typography>
    </Box>
  );
}
